import { useEffect, useState } from 'react'

export function useDebounce<T>(
  value: T,
  delay?: number,
): { debouncedValue: T; isDebouncing: boolean } {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)
  const [isDebouncing, setIsDebouncing] = useState<boolean>()

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 250)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  useEffect(() => {
    if (value || isDebouncing !== undefined) setIsDebouncing(true)
  }, [value])

  useEffect(() => {
    if (isDebouncing !== undefined) setIsDebouncing(false)
  }, [debouncedValue])

  return { debouncedValue, isDebouncing: isDebouncing ?? false }
}
